/**
 * region for libraries*/
import React, { Component, Fragment } from 'react';
import ReactApexChart from "react-apexcharts";


/**
 * region for component*/
import { WorkingLayer } from '../../../../components/common/WorkingLayer';

/**
 * region for helpers*/
import ajax from '../../../../helpers/ajax';
import typing from '../../../../helpers/typing';
import list from '../../../../helpers/list';

/**
 * region for constants*/
import Constants from '../../../../constants/Constants'



export class CategoriesDistributionChart extends Component {
    static displayName = CategoriesDistributionChart.name;

    constructor(props) {
        super(props);

        const self = this;

        this.state = {
            mode: Constants.MODE_LOADING,
            options: self.getChartOptions(),
            series: [],
            seriesLabel: []
        }
    }

    getChartOptions(title, labels) {
        const self = this;

        return {
            labels: labels || [],
            responsive: [{
                breakpoint: 1500,
                options: {
                    chart: {
                        width: 320,
                        height: 220
                    },
                    legend: {
                        position: 'left'
                    },
                    plotOptions: {
                        radialBar: {
                            size: 120,
                            hollow: {
                                size: '35%',
                            }
                        }
                    },
                }
            }],
            chart: {
                offsetX: 20,
            },
            tooltip: {
                enabled: true,
                shared: true,
                fillSeriesColor: false,
                theme: 'light',
                style: {
                    fontSize: '12px',
                    fontFamily: undefined
                },
                onDatasetHover: {
                    highlightDataSeries: false,
                },
                y: {
                    formatter: function (label) {
                        let index = list.getIndex(self.state.series, function (serie) { return serie === label; });
                        let text = self.state.seriesLabel[index];
                        return text;
                    },
                    title: {
                        formatter: function (seriesLabel) { return seriesLabel },
                    }
                },
                marker: {
                    show: true,
                }
            },
            plotOptions: {
                radialBar: {
                    size: 140,
                    hollow: {
                        margin: 0,
                        size: '40%',
                    }
                }
            },
            colors: ['#663399', '#00BFFF', '#FFD700','#74A4CE','#158F76','#FD5E75','#E6CA9C'],

            legend: {
                show: true,
                position: 'left',
                floating: true,
                offsetY: 25,
                fontWeight: 100,
                markers: {
                    width: 10,
                    height: 10,
                },
                itemMargin: {
                    horizontal: 0,
                    vertical: 0
                },
                onItemClick: {
                    toggleDataSeries: true
                },
                onItemHover: {
                    highlightDataSeries: true
                },
            },
            title: {
                text: title || 'Loading...',
                offsetY: -5,
                offsetX: -10,
                align: 'left',
                floating: true,
                style: {
                    fontSize: '20px',
                    fontWeight: 100,
                    color: '#404040'
                },
            },
            subtitle: {
                text: 'Categories',
                offsetY: 18,
                offsetX: -10,
                style: {
                    fontWeight: 100
                },
                floating: true,
                margin: 5,
                align: 'left'
            }
        }
    }

    load() {

        const self = this;

        ajax.get(Constants.ROUTE_API_DASHBOARD_CATEGORIES_DISTRIBUTION,
            {
                success: function (response) {                    
                    let seriesUpdated = response.data.map(serie => ((serie.SUMMATION / serie.TOTAL) * 100).toFixed(2));
                    let seriesUpdatedLabel = response.data.map(serie => typing.numberWithCommas(serie.SUMMATION));
                    let labelsUpdated = response.data.map(label => label.PUBLIC_NAME);

                    self.setState({
                        mode: Constants.MODE_LOADED,
                        options: self.getChartOptions(typing.numberWithCommas(response.data[0].TOTAL), labelsUpdated), 
                        series: seriesUpdated,
                        seriesLabel: seriesUpdatedLabel
                    });
                }
            });
    }

    componentDidMount() {
        const self = this;
        self.load();
    }


    render() {

        if (this.state.mode === Constants.MODE_LOADING) {
            return <WorkingLayer />
        }

        return (
            <Fragment>
            <div className="chart-container">
              <ReactApexChart options={this.state.options} series={this.state.series} type="radialBar" height={332}/>
            </div>
          </Fragment>
        )
    }
}



    

   
